module.exports = {
    urlLightningConfig: process.env.REACT_APP_URL_LIGHTNING_CONFIG || "https://kumwelllws.com",
    urlAuth: process.env.REACT_APP_URL_AUTH || "https://kumwelllws.com",
    urlSettingNotification: process.env.REACT_APP_URL_SETTING_NOTIFICATION || "https://kumwelllws.com",
    urlNotification: process.env.REACT_APP_URL_NOTIFICATION || "https://kumwelllws.com",
    urlWebsocket: process.env.REACT_APP_URL_WEBSOCKET || "ws://kumwelllws.com",
    urlSound: process.env.REACT_APP_URL_SOUND || "https://kumwelllws.com:",
    urlDevice: process.env.REACT_APP_URL_DEVICE || "https://kumwelllws.com",
    urlTestWarning: process.env.REACT_APP_URL_TEST_WARNING || "https://kumwelllws.com:",
};
